var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('restaurant-form',{model:{value:(_vm.restaurant),callback:function ($$v) {_vm.restaurant=$$v},expression:"restaurant"}})}
var staticRenderFns = []

export { render, staticRenderFns }